import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Card,
  Link,
  Typography,
  Container,
  styled,
  // Alert,
} from '@mui/material'
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles'
import { Helmet } from 'react-helmet-async'
import JWTLogin from '../LoginJWT'
import { useTranslation } from 'react-i18next'
import Scrollbar from 'src/components/Scrollbar'
import MinipayPromo from './MinipayPromo'

const Content = styled(Box)(
  () => `
    display: flex;
    flex: 1;
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
`
)

const MainContent = styled(Box)(
  ({ theme }) => `
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0 0 0 440px;
  }
  width: 100%;  
  display: flex;  
  align-items: center;  
`
)

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: #EAF7EF;
    width: 440px;
`
)

const SidebarContent = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(6)};
`
)

function LoginCover() {
  const { t } = useTranslation()
  const baseTheme = useTheme()
  // Tema claro + verde, exclusivo do minipay — herda o tema base (mantém as
  // extensões custom como theme.colors.*) só sobrescrevendo a paleta.
  const minipayTheme = createTheme(baseTheme, {
    palette: {
      mode: 'light',
      primary: { main: '#1FAA59' },
      background: { default: '#ffffff', paper: '#ffffff' },
      text: { primary: '#0B2818', secondary: '#3F6B52' },
    },
  })

  return (
    <ThemeProvider theme={minipayTheme}>
      <Helmet>
        <title>Login Youon</title>
      </Helmet>
      <Content>
        <SidebarWrapper
          sx={{
            display: { xs: 'none', md: 'flex' },
          }}
        >
          <Scrollbar>
            <SidebarContent>
              <MinipayPromo />
            </SidebarContent>
          </Scrollbar>
        </SidebarWrapper>
        <MainContent>
          <Container
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // flexDirection: 'column',
            }}
            maxWidth="sm"
          >
            <Card
              sx={{
                p: 4,
                my: 4,
              }}
            >
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{
                    mb: 1,
                  }}
                >
                  {t('Entrar')}
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  fontWeight="normal"
                  sx={{
                    mb: 3,
                  }}
                >
                  {t('Preencha os campos abaixo para entrar em sua conta.')}
                </Typography>
              </Box>
              <JWTLogin />
              <Box my={4}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {t('Não tem uma conta ainda?')}
                </Typography>{' '}
                <Box display={{ xs: 'block', md: 'inline-block' }}>
                  <Link component={RouterLink} to="/minipay/register">
                    <b>Crie Aqui</b>
                  </Link>
                  {/* <Link component={RouterLink} to="/emailValidation">
                    <b>Email Validation </b>
                  </Link> */}
                </Box>
              </Box>
            </Card>
          </Container>
        </MainContent>
      </Content>
    </ThemeProvider>
  )
}

export default LoginCover
